import * as React from 'react'
import { usePopoverActions } from '../../hooks'
import { LocationsPopoverProps } from '../../typings'

import Popover from '@mui/material/Popover'
import Fade from '@mui/material/Fade'
import { LocationsPopoverContentSelector } from './LocationsPopoverContentSelector'

const styles = {
  popoverRoot: {
    display: 'flex',
    justifyContent: 'center',
    alignItems: 'center',
  },
}
export const LocationsListPopover: React.FC<LocationsPopoverProps> = (
  props,
) => {
  const { open, onClose, anchorEl } = props

  const popoverActions = usePopoverActions()
  const { popoverActionsRef, updatePosition } = popoverActions

  return (
    <Popover
      sx={{
        root: styles.popoverRoot,
      }}
      open={open}
      onClose={onClose}
      anchorEl={anchorEl}
      anchorOrigin={{
        vertical: 'bottom',
        horizontal: 'left',
      }}
      transformOrigin={{
        vertical: 'top',
        horizontal: 'left',
      }}
      elevation={3}
      action={popoverActionsRef}
      TransitionComponent={Fade}
      TransitionProps={{
        onEntered: updatePosition,
      }}
    >
      <LocationsPopoverContentSelector {...props} {...popoverActions} />
    </Popover>
  )
}
LocationsListPopover.displayName = 'LocationsListPopover'
